// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"364":"80f7053c","584":"c594d32d"}[chunkId] + ".chunk.css";
};